// extracted by mini-css-extract-plugin
module.exports = {"ProjectList":"ProjectList_ProjectList__ASQMu","Project":"ProjectList_Project__JqSoL"};